<script setup lang="ts">
import {
    AlertDialog,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
    AlertDialogTrigger,
} from '@/components/ui/alert-dialog'
import { Button } from '@/components/ui/button'
import { router } from '@inertiajs/vue3'
import { Trash2 } from 'lucide-vue-next'
import { inject, ref } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const isOpen = ref(false)

const { sessionCart } = inject<{
    sessionCart?: string
}>('stepControl', {
    sessionCart: '',
})

function handleRemove() {
    router.delete(`/${sessionCart ? 'session_' : ''}cart/remove_item/${props.ticketId}`, {
        only: ['cart', 'flash', 'current_cart', 'coupon'],
        preserveScroll: true,
    })

    isOpen.value = false
}

const props = defineProps<{
    ticketId: number
}>()
</script>

<template>
    <AlertDialog :open="isOpen" @update:open="isOpen = $event">
        <AlertDialogTrigger class="hover:text-destructive cursor-pointer text-gray-400"> <Trash2 class="w-[24px]" /> </AlertDialogTrigger>
        <AlertDialogContent>
            <AlertDialogHeader>
                <AlertDialogTitle>{{ t('Are you absolutely sure?') }}</AlertDialogTitle>
                <AlertDialogDescription>{{ t('This action cannot be undone.') }}</AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
                <AlertDialogCancel>{{ t('Cancel') }}</AlertDialogCancel>
                <Button variant="destructive" @click="handleRemove">{{ t('Remove') }}</Button>
            </AlertDialogFooter>
        </AlertDialogContent>
    </AlertDialog>
</template>
